/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useLocation, matchPath, useHistory } from 'react-router';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Divider,
  Drawer,
  List,
  IconButton,
  SvgIcon,
  Toolbar,
  makeStyles
} from '@material-ui/core';
// import Logo from 'src/components/Logo';
import { X as XIcon } from 'react-feather';
import NavItem from './NavItem';

const navConfig = [
  {
    subheader: 'buttons',
    items: [
      {
        title: 'Home',
        // icon: PieChartIcon,
        href: '/home'
      },
      {
        title: 'About Us',
        // icon: GridIcon,
        href: '/about-us'
      },
      {
        title: 'News',
        // icon: GridIcon,
        href: '/app/solar-panels/news'
      },
      {
        title: 'Events',
        // icon: GridIcon,
        href: '/app/solar-panels/events'
      },
      {
        title: 'See Full Inventory',
        // icon: GridIcon,
        href: '/app/solar-panels'
      },
      {
        title: 'Re+ 2026',
        // icon: GridIcon,
        href: '/re-plus-las-vegas-2026'
      },
      {
        title: 'Safe Harbor',
        // icon: GridIcon,
        href: '/safe-harbor'
      },
      {
        title: 'Custom Procurement',
        // icon: GridIcon,
        href: '/custom-procurement'
      },
      {
        title: 'Contact Us',
        // icon: GridIcon,
        href: '/contact'
      }
    ]
  }
];

function renderNavItems({ items, ...rest }) {
  return (
    <List disablePadding >
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, ...rest }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({
  acc,
  pathname,
  item,
  depth = 0
}) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={key}
        info={item.info}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={key}
        info={item.info}
        title={item.title}
        pathname = {pathname}
      />
    );
  }

  return acc;
}

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: '100%',
    backgroundColor: '#1F242D',
    color: '#ffffff',
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    width: 100,
    height: 100,
    backgroundColor: "#1c2025"
  },
  blueUnderlineMobile: {
    textDecoration: 'none',
    borderBottom: '1px solid #009eda',
    display: 'inline',
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "34px",
    height: "43px"
  },
  imageDesktop: {
    width: '65px',
    margin: "10px 0px",
    marginLeft: "16px",
    height: "35px",
    cursor: 'pointer',
  },
  toolbar: {
    maxHeight: 30,
    position: "relative"
  },
}));

function NavBar({ openMobile, onMobileClose, hideLoginButton }) {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <Toolbar className={classes.toolbar}>
        <img
          className={classes.imageDesktop}
          alt="1000 Containers"
          src="/static/1000containers-logo-white.svg"
          onClick={() => history.push('/app/solar-panels')}
          role="button"
        />
        <IconButton
          onClick={onMobileClose}
          style={{
            position: 'absolute',
            right: 24,
          }}
        >
          <SvgIcon style={{ fontSize: "28px" }}>
            <XIcon color='white' />
          </SvgIcon>
        </IconButton>
      </Toolbar>
      <Divider style={{ height: "1px", backgroundColor: "#1f242d", boxShadow: "0px 2px 2px 3px #1d2127" }} />
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Box p={2}>
          {navConfig.map((config) => (
            <List
              key={config.subheader}
            >
              {renderNavItems({ items: config.items, pathname: location.pathname })}
            </List>
          ))}
        </Box>
        {!hideLoginButton && (
          <Box display='flex' justifyContent='center'>
            <Button style={{ position: "relative", backgroundColor: "#009eda", margin:"32px 0px", borderRadius: "25px", height: "40px", width: "145px", textTransform: "none", color: "white", fontSize: "14px" }} onClick={() => history.push("/login")}>
              <Box style={{ width: "7px", height: "7px", background: "white", borderRadius: "50%", position: "absolute", top: "50%", left: "14%", transform: "translateY(-50%)" }}></Box>Login
            </Button>
          </Box>
        )}
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      {/* Not breakpoint-gated: TopBar also collapses to the menu icon on narrow desktops. */}
      <Drawer
        anchor="top"
        classes={{ paper: classes.mobileDrawer }}
        onClose={onMobileClose}
        open={openMobile}
        variant="temporary"
      >
        {content}
      </Drawer>
      {/* <Hidden smDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden> */}
    </>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
  hideLoginButton: PropTypes.bool,
};

export default NavBar;
